"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var OrgEntitlementDetails = /*#__PURE__*/function () {
  OrgEntitlementDetails.$inject = ["entitlementsService"];
  /* @ngInject */
  function OrgEntitlementDetails(entitlementsService) {
    _classCallCheck(this, OrgEntitlementDetails);
    this.entitlementsService = entitlementsService;
  }
  return _createClass(OrgEntitlementDetails, [{
    key: "$onInit",
    value: function $onInit() {
      var _this = this;
      var _this$entitlement = this.entitlement,
        type = _this$entitlement.type,
        id = _this$entitlement.id,
        parentEntitlementId = _this$entitlement.parentEntitlementId;

      // entitlement provided can be used directly, or details can be fetch
      if (!this.fetch) {
        this.entitlementDetails = this.entitlement;
        return;
      }

      // tag a entitlement where we retrieve the parent to get details, but is expired
      var isExpired = this.isExpired = type === this.entitlementsService.TYPE_EXPIRED || type === this.entitlementsService.TYPE_EXPIRED_EVENT;

      // for experired, retrieve parent entitlement as it's more relevant
      var retrievedId = isExpired ? parentEntitlementId : id;

      // retrieve entitlement details
      this.loading = true;
      this.entitlementsService.getEntitlement(this.organization._id, retrievedId).then(function (entitlement) {
        return _this.entitlementDetails = entitlement;
      }).finally(function () {
        return _this.loading = false;
      });
    }
  }]);
}();
module.exports = angular.module('backstage.components.orgs.view-org.entitlements-manager.org-entitlement-details', ['backstage.services']).component('bsOrgEntitlementDetails', {
  templateUrl: '/src/angular/components/orgs/view-org/org-entitlements-manager/org-entitlement-details/org-entitlement-details.html',
  bindings: {
    entitlement: '<',
    organization: '<',
    fetch: '@'
  },
  controller: OrgEntitlementDetails
}).name;